import { createContext, useState, useEffect } from "react";
import CryptoJS from "crypto-js";

export const AuthContext = createContext();

const SECRET_KEY = "cozimax_portal_colaborador_2026";

function encrypt(data) {
  const json = JSON.stringify(data);
  return CryptoJS.AES.encrypt(json, SECRET_KEY).toString();
}

function decrypt(data) {
  try {
    const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  } catch (error) {
    console.error("Erro ao descriptografar:", error);
    return null;
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loadingAuth, setLoadingAuth] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem("colaborador");

    if (storedUser) {
      const userData = decrypt(storedUser);
      if (userData) {
        setUser(userData);
      }
    }

    setLoadingAuth(false);
  }, []);

  function login(userData) {
    const encrypted = encrypt(userData);

    localStorage.setItem("colaborador", encrypted);

    setUser(userData);
  }

  function logout() {
    localStorage.removeItem("colaborador");
    localStorage.removeItem("fotoFuncionario");
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, loadingAuth }}>
      {children}
    </AuthContext.Provider>
  );
}